import { __exports as t } from "./index181.js";
Object.defineProperty(t, "__esModule", { value: !0 });
t.camelCase = void 0;
var i = /^--[a-zA-Z0-9_-]+$/, E = /-([a-z])/g, s = /^[^-]+$/, _ = /^-(webkit|moz|ms|o|khtml)-/, l = /^-(ms)-/, m = function(a) {
  return !a || s.test(a) || i.test(a);
}, n = function(a, e) {
  return e.toUpperCase();
}, c = function(a, e) {
  return "".concat(e, "-");
}, u = function(a, e) {
  return e === void 0 && (e = {}), m(a) ? a : (a = a.toLowerCase(), e.reactCompat ? a = a.replace(l, c) : a = a.replace(_, c), a.replace(E, n));
};
t.camelCase = u;
export {
  t as default
};
